// extracted by mini-css-extract-plugin
export default {"row":"doc_row_1tB0Y","micromag":"doc_mic_2AiAu","video":"doc_vid_15HGu","article":"doc_art_1nanU"};